var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/84764944c688b0eb038bb3a30811c82b.js').default;
var scope_1 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8df4cc94e9daeb8dff58af12e8597795.js').default;
var scope_2 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a901b3efd93bedcc5ad9a3b4871df008.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    